const millisecondsInADay = 24 * 60 * 60 * 1000;

export const isAfterStartDate = (date: Date | null, startDate: Date | null): boolean => {
  if (date === null || startDate === null) {
    return false;
  }
  return (date !== null && date.getTime()) > (startDate !== null && startDate.getTime() - millisecondsInADay);
};

export const isAfterEndDate = (date: Date | null, endDate: Date | null): boolean => {
  if (date === null || endDate === null) {
    return false;
  }
  return (date !== null && date.getTime()) > (endDate !== null && endDate.getTime());
};

interface IsInRangeProps {
  date: Date | null;
  minDate: Date | undefined;
  maxDate: Date | undefined;
}

export const isInRange = ({ date, minDate, maxDate }: IsInRangeProps): boolean => {
  if (date === null) {
    return true;
  }
  if (minDate && maxDate) {
    return date.getTime() > minDate.getTime() && date.getTime() < maxDate.getTime();
  } else if (maxDate) {
    return date.getTime() < maxDate.getTime();
  } else if (minDate) {
    return date.getTime() > minDate.getTime();
  } else {
    return true;
  }
};
